import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { HistoriquePrixProduit } from '../../../../../../common/src/entities';
import ChampFormulaire from '../../../Common/ChampFormulaire';
import CheckboxFormulaire from '../../../Common/CheckboxFormulaire';
import { useFormikContext } from 'formik';
import { toISODate } from '../../../../Utils/dateUtils';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../../Utils/FormulaireCreationEntite';
import { MyPaper } from '../../Utils/MyPaper';

const LABEL_COL = 6;

export function ChampsHistoriquePrixProduit(): ReactElement {
    const { setFieldValue } = useFormikContext<HistoriquePrixProduit>();
    const { id } = useParams() as { id: string };
    useEffect(() => {
        setFieldValue('fk_id_produit', id);
    }, []);

    return (
        <div className="pb-5">
            <MyPaper>
                <CheckboxFormulaire id="facturation.b_taxable" titre="Taxable" />
                <ChampFormulaire
                    type="date"
                    id="date_debut"
                    titre="Date de début du prix"
                    parser={(date) => toISODate(date as string)}
                    labelCol={LABEL_COL}
                    estPetit
                />
                <ChampFormulaire
                    id="facturation.methode_facturation"
                    titre="Méthode de facturation"
                    suggestions={['Par participant', 'Par Groupe', 'Forfaitaire', "À l'heure"]}
                    labelCol={LABEL_COL}
                />
                <ChampFormulaire
                    id="facturation.prix_de_vente_fournisseur"
                    titre="Prix de vente du fournisseur"
                    type="number"
                    labelCol={LABEL_COL}
                />
                <ChampFormulaire
                    id="facturation.valeur_commission_dollar"
                    titre="Commission $"
                    type="number"
                    labelCol={LABEL_COL}
                />
                <ChampFormulaire
                    id="facturation.valeur_commission_pourcentage"
                    titre="Commission %"
                    type="number"
                    labelCol={LABEL_COL}
                />
                <ChampFormulaire
                    id="facturation.valeur_surfacturation_dollar"
                    titre="Surfacturation $"
                    type="number"
                    labelCol={LABEL_COL}
                />
                <ChampFormulaire
                    id="facturation.valeur_surfacturation_pourcentage"
                    titre="Surfacturation %"
                    type="number"
                    labelCol={LABEL_COL}
                />
            </MyPaper>
        </div>
    );
}

export default function DetailsHistoriquePrixProduit(
    props: Partial<PropsDeCreationEntite<HistoriquePrixProduit>>,
): ReactElement {
    return (
        <FormulaireCreationEntite
            texteEntete={(t: HistoriquePrixProduit) => (
                <>
                    <small className="text-muted">Modifier</small>&nbsp;{t.name}
                </>
            )}
            entite={HistoriquePrixProduit}
            {...props}
        >
            <ChampsHistoriquePrixProduit />
        </FormulaireCreationEntite>
    );
}
